import { uiLocaleCodes } from "./uiLocales"

export const defaultLanguage = "en"

export const availableLanguages = [...uiLocaleCodes]

export const langNames: Record<string, string> = {
  en: "English",
  ar: "العربية",
}
